import React from 'react'
import './Created.css'
import CollectionAsset from './CollectionAsset'
function Created() {
    return (
        <div className="CollectionAsset">
            
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
            <CollectionAsset
                ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
                Price = {4.89}
                Like = {453}
            />
        </div>
    )
}

export default Created
